/**
 * @generated SignedSource<<a4b28570e25501f40ddcbbdfe86da4f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateResumeInput = {
  clientMutationId?: string | null | undefined;
  copyToProfile?: boolean | null | undefined;
  filename?: string | null | undefined;
  mimetype?: string | null | undefined;
  url: string;
};
export type SocialLinksFields_ParseResumeMutation$variables = {
  input: CreateResumeInput;
};
export type SocialLinksFields_ParseResumeMutation$data = {
  readonly createResume: {
    readonly resume: {
      readonly id: string;
      readonly user: {
        readonly resume: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"resume_useIsImportingResume">;
        } | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"resume_useIsImportingResume">;
    } | null | undefined;
  } | null | undefined;
};
export type SocialLinksFields_ParseResumeMutation = {
  response: SocialLinksFields_ParseResumeMutation$data;
  variables: SocialLinksFields_ParseResumeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "resume_useIsImportingResume"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importTimeoutAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "copyToProfile",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SocialLinksFields_ParseResumeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateResumePayload",
        "kind": "LinkedField",
        "name": "createResume",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resume",
            "kind": "LinkedField",
            "name": "resume",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Resume",
                    "kind": "LinkedField",
                    "name": "resume",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SocialLinksFields_ParseResumeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateResumePayload",
        "kind": "LinkedField",
        "name": "createResume",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resume",
            "kind": "LinkedField",
            "name": "resume",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Resume",
                    "kind": "LinkedField",
                    "name": "resume",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99f26fb7d245389932813e6c35747c1f",
    "id": null,
    "metadata": {},
    "name": "SocialLinksFields_ParseResumeMutation",
    "operationKind": "mutation",
    "text": "mutation SocialLinksFields_ParseResumeMutation(\n  $input: CreateResumeInput!\n) {\n  createResume(input: $input) {\n    resume {\n      id\n      user {\n        resume {\n          id\n          ...resume_useIsImportingResume\n        }\n        id\n      }\n      ...resume_useIsImportingResume\n    }\n  }\n}\n\nfragment resume_useIsImportingResume on Resume {\n  id\n  status\n  importTimeoutAt\n  copyToProfile\n  user {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4449aa5701989a86ace6c553c57849d5";

export default node;
